<template>
  <div>
    <v-btn
      bottom
      class="secondary"
      dark
      fab
      fixed
      right
      id="createUserModalBtn"
      @click="dialog = !dialog"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card class="dlg-card">
        <v-form ref="form" v-model="valid">
          <dialog-header
            title="Create New User"
            icon="mdi-account-plus"
            @close="userCancel"
          />
          <v-divider></v-divider>

          <v-card-text class="dlg-body">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    id="firstName"
                    prepend-inner-icon="mdi-account"
                    label="First Name"
                    v-model="firstname"
                    :rules="[required('First name')]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    id="lastName"
                    prepend-inner-icon="mdi-account"
                    label="Last Name"
                    v-model="lastname"
                    :rules="[required('Last name')]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    prepend-inner-icon="mdi-domain"
                    :items="sections"
                    label="Department"
                    v-model="department"
                    :rules="[required('Department')]"
                    outlined
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    prepend-inner-icon="mdi-shield-account"
                    item-text="name"
                    item-value="value"
                    :items="roles"
                    label="Role"
                    v-model="assignedRole"
                    :rules="[required('Role')]"
                    outlined
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    prepend-inner-icon="mdi-email"
                    label="Email"
                    v-model="email"
                    :rules="[required('Email'), emailFormat()]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    type="tel"
                    prepend-inner-icon="mdi-phone"
                    label="Extension No."
                    v-model="extension"
                    :rules="[required('Extension No.'), numberFormat()]"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    prepend-inner-icon="mdi-map-marker"
                    :items="regions"
                    label="Region"
                    v-model="region"
                    :rules="[required('Region')]"
                    outlined
                    dense
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="dlg-actions">
            <v-spacer></v-spacer>
            <v-btn
              id="clearFormBtn"
              text
              color="grey darken-1"
              @click="clear"
              class="px-4"
            >
              <v-icon left small>mdi-broom</v-icon>
              Clear
            </v-btn>
            <v-btn
              id="closeModalBtn"
              text
              color="error"
              @click="userCancel"
              class="px-4"
            >
              <v-icon left small>mdi-close</v-icon>
              Cancel
            </v-btn>
            <v-btn
              id="inviteUserBtn"
              color="secondary"
              @click="inviteUser"
              :dialogInvite="dialogInvite"
              :loading="loading"
              :disabled="!valid"
              class="px-6"
              elevation="2"
            >
              <v-icon left small>mdi-account-plus</v-icon>
              Invite User
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import validation from '@/utils/Validations'
import axios from 'axios'
import DialogHeader from '@/components/DialogHeader'
export default {
  components: { DialogHeader },
  data: () => ({
    valid: false,
    firstname: '',
    lastname: '',
    department: '',
    assignedRole: '',
    email: '',
    region: null,
    extension: '',
    dialog: false,
    loading: false,
    dialogInvite: false,
    alert: false,
    sections: ['Motor Claims', 'Non-Motor Claims', 'Legal', 'Customer Service'],
    regions: [],
    rolesData: [], // Will be populated from Cognito groups
    ...validation,
  }),

  mounted: function () {
    this.fetchRegions()
    this.fetchRoles()
  },

  computed: {
    roles() {
      return this.$store.state.roles
    },
  },

  methods: {
    inviteUser() {
      this.dialogInvite = true
      this.loading = true

      const inviteData = {
        name: `${this.firstname} ${this.lastname}`,
        email: this.email,
        department: this.department,
        role: this.assignedRole,
        extension: this.extension,
        region: this.region,
      }

      axios
        .post('/motor-assessment/api/users/invite/BACK_OFFICE', inviteData)
        .then((response) => {
          // Check for success field in response
          if (response.data && response.data.success === false) {
            // Backend returned error in success response
            this.$toasted.error(response.data.msg || 'Failed to invite user', {
              duration: 5000,
            })
            this.loading = false
            return
          }

          // Success
          this.$toasted.success(
            `You have successfully added ${inviteData.name} as ${inviteData.role}`,
            { duration: 3000 }
          )
          this.userCancel()
          // Refresh user list
          this.$store.dispatch('fetchUser')
        })
        .catch((error) => {
          // Network or HTTP error
          const errorMsg =
            error.response?.data?.msg || error.message || 'An error occurred'
          this.$toasted.error(errorMsg, { duration: 5000 })
        })
        .finally(() => {
          this.loading = false
        })
    },

    fetchRegions() {
      axios
        .get('/motor-assessment/api/regions')
        .then((res) => {
          let regions = res.data.data
          this.regions = regions.map((region) => region.name)
        })
        .catch((err) => {
          this.$store.commit(
            'SNACKBAR',
            {
              state: 'failed',
              message: `${err.message}`,
              variant: 'error',
            },
            { root: true }
          )
        })
    },

    fetchRoles() {
      this.$store.dispatch('fetchRoles')
    },

    userCancel() {
      this.dialog = false
      this.$refs.form.reset()
    },

    clear() {
      this.$refs.form.reset()
    },
  },
}
</script>
